module.exports = __webpack_public_path__ + "media/images/browser-b5f57d7df7e8d22ade444c54185a9b14.svg";